<template lang="pug">
.container.admin
  router-view
  template(v-if='$route.fullPath === "/admin"')
    h1 系统管理
    router-link.ui.button.blue.icon.labeled(:to="'/admin/users'", v-if='$permission.has("system.users.edit")')
      i.ui.icon.users
      | 用户管理
    //router-link.ui.button.green.icon.labeled(:to="'/admin/rooms'", v-if='$permission.has("system.rooms.edit")')
      i.ui.icon.home
      | 房间管理
    //router-link.ui.button.olive.icon.labeled(:to="'/admin/permissions'", v-if='$permission.has("system.permissions.edit")')
      i.ui.icon.key
      | 权限管理
    router-link.ui.button.teal.icon.labeled(:to="'/admin/templates'", v-if='$permission.has("system.templates.edit")')
      i.ui.icon.file
      | 模板管理
    router-link.ui.button.teal.icon.labeled(:to="'/admin/meta'", v-if='$permission.has("system.meta.edit")')
      i.ui.icon.file
      | 资料管理

    br
    br
    br
    br
    br

    div(v-if='!$media.isMobile && $permission.has("*")')
      .ui.warning.icon.message
        i.icon.warning
        .content
          .header 危险区
          p 请谨慎进行以下操作，操作不当可能导致数据损坏或丢失。

      .ui.form: .four.fields
        .field
          label 备份/恢复
          .ui.red.buttons
            .ui.button(@click='backup()') 备份数据
            .ui.button(@click='restore_show()') 恢复数据

        .field
          label 补丁
          .ui.orange.buttons
            .ui.button(@click='patch("roles/update")') 更新角色权限信息


      el-dialog(:visible.sync='restore_dialog_visible', title='恢复数据')
        .ui.form
          .ui.field
            label 选择备份
            el-select(v-model='restore_dialog_selected', placeholder='选择备份')
              el-option(v-for='item in backups', :key='item', :label='item', :value='item')

        div(slot='footer')
          .ui.button(@click='restore_dialog_visible = false') 取消
          .ui.button.orange(@click='restore()', :class='{disabled:!restore_dialog_selected}') 恢复数据
</template>

<script>
import { MakeFetcher } from '../utils'

export default {
  name: 'admin',
  data() {
    return {
      restore_dialog_visible: false,
      restore_dialog_selected: null,
      backups: [],
    }
  },
  mounted() {
    if (this.$permission.has('*'))
      this.fetch_backups()
  },
  methods: {
    fetch_backups: MakeFetcher({
      url: 'system/backup/list',
      key: 'backups',
    }),
    backup() {
      this.$confirm('确定要手动备份吗？')
        .then(confirmed => {
          if (!confirmed) return
          this.$http.post('system/backup/backup')
            .then(r => {
              const { filename } = r.body
              this.$message({
                type: 'success',
                message: `备份成功！文件名：${filename}。`,
              })
            })
            .catch(this.$utils.DefaultErrorHandler.bind(this))
        })
    },
    restore() {
      const restore_to = this.restore_dialog_selected
      this.$confirm(`该操作无法撤销并可能回导致数据丢失。确定要恢复到备份 ${restore_to} 吗？`)
        .then(confirmed => {
          if (!confirmed) return
          this.$http.put(`system/backup/restore/${restore_to}`)
            .then(() => {
              this.$msgbox({
                type: 'success',
                message: '数据恢复完成。',
              }).then(() => {
                window.location.reload()
              }).catch(() => {
                window.location.reload()
              })
            })
            .catch(this.$utils.DefaultErrorHandler.bind(this))
        })
    },
    patch(url) {
      this.$confirm('确定？')
        .then(confirmed => {
          if (!confirmed) return
          this.$http.get(`system/patches/${url}`)
            .then(() => {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
            })
            .catch(this.$utils.DefaultErrorHandler.bind(this))
        })
    },
    restore_show() {
      this.restore_dialog_selected = this.backups[0]
      this.restore_dialog_visible = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// Admin.vue?44757fc6